
  function updateTitle(vm){
    const seo = vm.$store.getters['glb/getSeoInfo'];
    if (seo && seo.title != document.title) {
      document.title = seo.title;
    }
  }
  function updateMeta(vm){
    const meta = vm.$store.getters['glb/getMetaObj'];
    var canonicalLink = document.head.querySelector('[rel="canonical"]');
    if  (meta && meta.canonicalUrl && canonicalLink)  {
        canonicalLink.href = vm.glb.appUrl + meta.canonicalUrl;
    }
  }
  const clientTitleMixin = {
    updated() {
      updateTitle(this);
    },
    methods: {
      updateBrowserInfo: function() {
        updateTitle(this);
        updateMeta(this);
      }
    }
  };

  export default clientTitleMixin;
